export * from './CustomerDetailsPage';
export * from './completedCustomerDetails';
